module.exports = __webpack_public_path__ + "img/1.ab86ae8b.png";